import React from 'react';

interface IProps {
  className?: string;
}

export function ArrowDown(props: IProps) {
  return (
    <svg
      width={10}
      height={11}
      viewBox="0 0 10 11"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{'Arrow down'}</title>
      <g
        stroke="red"
        strokeWidth={1.152}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M5.032.576v9.792M9.064 6.336l-4.032 4.032L1 6.336" />
      </g>
    </svg>
  );
}
